



























































import { defineComponent, toRefs, PropType, computed } from '@vue/composition-api';
import {
  RejectInfo,
  AcoFormData,
  AdgroupFormData,
  CampaignFormData,
  FullNormalFormData,
  ACTION_TYPE,
  NormalCreative,
} from '@tt4b/ttam-enums';
import { useStore } from '@tt4b/ttam-hooks';
import { useTikTokIdentityDisplayProps } from './../../identity/hooks';
// import CatalogAlert from '@/components/common/catalog-alert';

import CreativeAlert from './index';

const name = 'ttam-creative-alert-compose';

const {
  // TtamCreativeIdentityNoInfoAlert,
  TtamCreativeIdentityUnavailableAlert,
  TtamCreativeIos14Alert,
  TtamCreativeRejectAlert,
  TtamCreativeSplittestAlert,
  TtamCreativeAppProfilePageTypeAlert,
  // TtamCreativeShopAlert,
  TtamCreativeCopyAlert,
  TtamCreativeAnchorAlert,
  TtamCreativeAllProductUnavailableAlert,
  TtamCreativeAuthShopAlert,
  TtamCreativeCreateAuthShopAlert,
} = CreativeAlert;

export default defineComponent({
  name,
  components: {
    // TtamCreativeCatalogAuthAlert: CatalogAlert.CatalogAuthAlert,
    // TtamCreativeIdentityNoInfoAlert,
    TtamCreativeIdentityUnavailableAlert,
    TtamCreativeAppProfilePageTypeAlert,
    TtamCreativeIos14Alert,
    TtamCreativeRejectAlert,
    TtamCreativeSplittestAlert,
    TtamCreativeCopyAlert,
    TtamCreativeAnchorAlert,
    TtamCreativeAllProductUnavailableAlert,
    TtamCreativeAuthShopAlert,
    TtamCreativeCreateAuthShopAlert,
    // TtamCreativeShopAlert,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    normalCreativeData: {
      type: Object as PropType<NormalCreative>,
      default: () => ({}),
    },
    rejectInfo: {
      type: Object as PropType<RejectInfo>,
      default: () => ({}),
    },
    createMode: {
      type: String,
      default: () => ACTION_TYPE.CREATE,
    },
  },
  setup(props, { emit }) {
    const { campaignData, adgroupData, creativeData, createMode, rejectInfo, normalCreativeData } = toRefs(props);

    // const { authAlertVisible } = CatalogAlert.useCatalogAlertProps({
    //   adgroupData,
    //   createMode,
    //   campaignData,
    // });
    const curIdentity = computed(() => ({
      identityId: creativeData.value.identityId as string,
      identityTtsShopId: creativeData.value.identityTtsShopId as string,
      identityType: creativeData.value.identityType as number,
      identityBcId: creativeData.value.identityBcId as string,
    }));

    const { canUseShowcase } = useTikTokIdentityDisplayProps({
      identityInfo: curIdentity,
      adgroupData,
      creativeData,
    });

    const {
      unavailableMessage,
      unavailableVisible,
      noInfoVisible,
      unavailableAlertType,
      isStandardAdsWithShop,
      isStandardAdsWithCatalog,
      isStandardAdsWithShowcase,
      isProductFromCatalog,
    } = CreativeAlert.useIdentityAlertProps({
      creativeData,
      createMode,
      adgroupData,
      campaignData,
      normalCreativeData,
    });
    const { visible: isShowAnchorAlert } = CreativeAlert.useCreativeAnchorAlert({
      campaignData,
      adgroupData,
      normalCreativeData,
    });
    const { visible: isShowAllProductUnavailableAlert } = CreativeAlert.useCreativeAllProductUnavailableAlert({
      createMode,
      campaignData,
      adgroupData,
      creativeData,
      emit,
    });
    const { visible: splittestVisible } = CreativeAlert.useSplittestAlertPropsVisible({
      createMode,
    });

    const { visible: appProfilePageTypeAlertVisible } = CreativeAlert.useAppProfilePageTypeAlertPropsVisible({
      campaignData,
    });

    const { visible: rejectAlertVisible } = CreativeAlert.useRejectAlertPropsVisible({
      rejectInfo,
      createMode,
    });

    const { visible: ios14Visible } = CreativeAlert.useIos14AlertPropsVisible({
      adgroupData,
      createMode,
    });

    const { visible: copyBannerVisible, copyBannerErrorMap } = CreativeAlert.useCreativeCopyAlert();
    const { isNotAccessShopOrCatalogEditAd } = CreativeAlert.useAccessShopOrCatalogEditAd({
      campaignData,
      adgroupData,
      createMode,
      canUseShowcase,
    });
    const { isNotAccessShopOrShowcaseCreateAd } = CreativeAlert.useAccessShopOrShowcaseCreateAd({
      campaignData,
      adgroupData,
      createMode,
      canUseShowcase,
    });
    const { state } = useStore();

    return {
      name,
      isShowAnchorAlert,
      splittestVisible,
      appProfilePageTypeAlertVisible,
      rejectAlertVisible,
      ios14Visible,
      copyBannerVisible,
      copyBannerErrorMap,
      isShowAllProductUnavailableAlert,
      aadvid: computed(() => state.baseInfo.value?.aadvid),
      unavailableMessage,
      unavailableVisible,
      unavailableAlertType,
      isStandardAdsWithShop,
      isStandardAdsWithCatalog,
      isStandardAdsWithShowcase,
      isProductFromCatalog,
      isNotAccessShopOrCatalogEditAd,
      isNotAccessShopOrShowcaseCreateAd,
    };
  },
});
